"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleShiftTypePolicies = void 0;
exports.scheduleShiftTypePolicies = {
    ScheduleShift: {
        keyFields: ['shift', ['id']]
    }
};
